export default __webpack_public_path__ + "media/c90bfa2318aad67e9e04926a6bce44903aa00266a1fbe01943de0e38ac113b8a.svg";